import PropTypes from "prop-types";
import useTable from "./useTable";
import Header from "./Header";
import Body from "./Body";
import TableContext from "./TableContext";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";

function Table({
  children,
  className,
  columns,
  data = [],
  id,
  height,
  maxHeight = "unset",
  maxWidth = "unsert",
  pinnedColumns,
  stickyHeader = false,
  style = {},
  width,
}, ref) {
  let table, setTableData;

  // Using a hook inside a conditional is generally bad practice.
  // Made an exception here because this is owned by LDS and test
  // coverage ensures we don't break rendering. For more info on
  // why we client code shouldn't do this: https://react.dev/reference/rules/rules-of-hooks
  if (!children) {
    const useTableResult = useTable({
      columns,
      config: {
        pinnedColumns,
      },
      data,
    });

    table = useTableResult.table;
    setTableData = useTableResult.setTableData;
  }

  useImperativeHandle(ref, () => ({
    table
  }), [])

  const classNames = ["lds-table", className];

  const styles = {
    height,
    width,
  };

  let childrenToRender;

  if (children) {
    childrenToRender = children;
  } else {
    childrenToRender = (
      <>
        <Header sticky={stickyHeader} />
        <Body />
      </>
    );
  }

  return (
    <TableContext.Provider value={{ table, setData: setTableData }}>
      <div className="lds-table-wrapper" style={{ maxHeight, maxWidth }}>
        <table
          className={classNames.join(" ")}
          id={id}
          data-testid={id}
          style={{ ...styles, ...style }}
        >
          {childrenToRender}
        </table>
      </div>
    </TableContext.Provider>
  );
}

Table.propTypes = {
  className: PropTypes.string,
  children: PropTypes.element,
  columns: PropTypes.array,
  data: PropTypes.array,
  debug: PropTypes.bool,
  id: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ref: PropTypes.any,
  stickyHeader: PropTypes.bool,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  pinnedColumns: PropTypes.array,
};

export default forwardRef(Table)